/*
 *
 * CommerceWebTenantPopup
 *
 */
import CommerceWebTenantPopup from './CommerceWebTenantPopupContainer'

export default CommerceWebTenantPopup
